import {Controlled_ProcessAreaTextField} from "./Controlled_ProcessAreaTextField";
import {Controlled_WorkflowRepresentationTextField} from "./Controlled_WorkflowRepresentationTextField";
import {Controlled_ImageAttachmentTextField} from "./Controlled_ImageAttachmentTextField";
import { Controlled_CriteriaTextField } from './Controlled_CriteriaTextField';
import { Controlled_MethodTextField } from './Controlled_MethodTextField';
import { Controlled_ObjectiveTextField } from './Controlled_ObjectiveTextField';
import { Controlled_ProcessArtifactTextField } from './Controlled_ProcessArtifactTextField';
import { Controlled_RoleTextField } from './Controlled_RoleTextField';
import { Controlled_ToolTextField } from './Controlled_ToolTextField';
import { Controlled_VerificationMetricTextField } from './Controlled_VerificationMetricTextField';

export const ControlledReferenceInputs = {
    ProcessArea: Controlled_ProcessAreaTextField,
    WorkflowRepresentation: Controlled_WorkflowRepresentationTextField,
    ImageAttachment: Controlled_ImageAttachmentTextField,
    Criteria: Controlled_CriteriaTextField,
    Method: Controlled_MethodTextField,
    Objective: Controlled_ObjectiveTextField,
    ProcessArtifact: Controlled_ProcessArtifactTextField,
    Role: Controlled_RoleTextField,
    Tool: Controlled_ToolTextField,
    VerificationMetric: Controlled_VerificationMetricTextField
};
